import { ValueFunction } from '../../';

function methodSimplePayment({apr, term, amount}) {
  if (apr && term && amount) {
    return amount * (apr/12 * (1+apr/12)**term) / ((1+apr/12)**term - 1);
  } else if (term && amount) {
    return amount / term;
  } else {
    return null;
  }
}

export const simplePayment = new ValueFunction(
  methodSimplePayment,
  {
    label: 'Calculate the Payment from a Loan Structure',
    description: 'pmt(apr, term, amount)',
    parameters: [
      {'name': 'apr', 'type': 'number'},
      {'name': 'term', 'type': 'number'},
      {'name': 'amount', 'type': 'number'}
    ],
    maxLength: 3
  }
);